export const TaskActionTypes = {
  // todo we need to sort out these names
  REFRESH_TASKS: "REFRESH_TASKS",
  REFRESH_TASKS_SUCCESS: "REFRESH_TASKS_SUCCESS",
  FETCH_TASK: "FETCH_TASK",
  FETCH_TASK_SUCCESS: "FETCH_TASK_SUCCESS",
  SUBMIT_TASK_RESPONSE: "SUBMIT_TASK_RESPONSE",
};
